import { render } from "./LifecycleTest.vue?vue&type=template&id=6de37646&scoped=true&lang=true"
import script from "./LifecycleTest.vue?vue&type=script&lang=js"
export * from "./LifecycleTest.vue?vue&type=script&lang=js"

import "./LifecycleTest.vue?vue&type=style&index=0&id=6de37646&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de37646"]])

export default __exports__